import { MultiSelectProps } from '@conexasaude/hero-web'

export class Registry {
  public name: string = ''
  public lastName: string = ''
  public birthday: Date = null
  public email: string = ''
  public hometown: string = ''
  public password: string = ''
  public celular: string = ''
  public cpf: string = ''
  public crm: string = ''
  public ufCrm: string = ''
  public sex: string = ''
  public hasBirdId: boolean = false
  public hasCnpj: boolean = false
  public preferenceForAttendance: string = ''
  public speciality: string = ''
  public anotherSpeciality: string = ''
  public serviceAvailability: MultiSelectProps[] = []

  static createRegistry(): Registry {
    return new Registry()
  }
}
